import React from "react";

export default function Badge({ status }) {
  if (!status) return null;
  let badgeColor = "alert-";
  status = status?.indexOf("_") > -1 ? status?.replace("_", " ").toLowerCase() : status?.toLowerCase();

  switch (status) {
    case "completed":
    case "approved":
    case "deposit":
    case "success":
    case "approve":
    case "delivered":
      badgeColor += "success";
      break;
    case "pending":
    case "PENDING":
    case "internal transfer":
    case "in progress":
      badgeColor += "warning";
      break;
    case "failed":
    case "withdraw":
    case "rejected":
    case "reject":
      badgeColor += "danger";
      break;
    default:
      badgeColor += "light";
  }

  return (
    <span className={`w-md-50 m-auto py-0 alert text-capitalize ${badgeColor}`}
    >{status}</span>
  );
}